import { useFilters } from "@/hooks/useFilters";
import { PeriodRadio } from "./PeriodRadio";
import { MetricRadio } from "./MetricRadio";

/** Two-column row: [Periodo] [Ordenar por]. The scope control is NOT
 * here — it lives in TabsNav to match the design call (scope floats on
 * the right of the tab strip in a single line). A hairline divider
 * sits between the two columns so the eye reads them as peers, not a
 * chaotic row. */
export function FiltersRow() {
  const { filters, setFilter } = useFilters();

  return (
    <section
      aria-label="Filtros globales"
      className="relative mb-5 grid grid-cols-[1fr_1px_1fr] items-center gap-6 rounded-[20px] border border-border-1 bg-white/[0.02] p-4"
    >
      <div className="flex flex-col gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-text-4">
          Periodo
        </span>
        <PeriodRadio
          value={filters.period}
          onChange={(v) => setFilter("period", v)}
        />
      </div>
      <span
        aria-hidden
        className="h-10 w-px self-center bg-gradient-to-b from-transparent via-border-2 to-transparent"
      />
      <div className="flex flex-col items-end gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-text-4">
          Ordenar por
        </span>
        <MetricRadio
          value={filters.metric}
          onChange={(v) => setFilter("metric", v)}
        />
      </div>
    </section>
  );
}
